<template>
	<div>
		<div v-for='(item,ind) in firstlist' :key='ind'>
			<a-row>
				<a-col :span='12'>
					<div v-if='ind == 4' style="font-weight: 600;" class='warp_back1'>
						{{item.name}}
					</div>
					<div v-else  class='warp_back1'>
						{{item.name}}
					</div>
				</a-col>
				<a-col :span='12'>
					<div v-if='ind == 4' style="background-color: #dbf5ae;position: relative;" class='warp_back2'>
						{{item.num}}
						 <img :src="require('@/image/simu/more.png')" alt="" style="position: absolute;right: 1rem;width: 1rem;top: .5rem;">
					</div>
					<div v-else-if='ind == 15||ind == 16||ind == 17' style="font-weight: 600;" class='warp_back2'>
						{{item.num}}
					</div>
					<div v-else class='warp_back2' :style='item.color?"color:red":""'>
						{{item.num}}
					</div>
				</a-col>
			</a-row>
		</div>
	
	</div>
</template>

<script>
	export default {
		props: ['firstlist']
	}
</script>

<style lang='scss'>
	.warp_back1{
		background-color: #bfd9f2;
		font-size: 1.1rem;
		padding: .11rem 0 0.11rem 0.2rem;
	}
	
	.warp_back2{
		background-color: #e3effb;
		font-size: 1.1rem;   
		padding: .11rem 0 0.11rem 0.2rem;
	}
</style>
